import { EntityTypeEnum } from "@app/projects/enumerators";
import { NetworkIntegrityActionStatus } from "@app/projects/network-assessment/network-integrity/filters/networkIntegrityFilterConstants";
import { NetworkIntegrityProviderSelectionMode, NetworkIntegrityProviderSelectionState, NetworkIntegrityProviderSelectionStateDto } from "@app/projects/network-assessment/network-integrity/models";

const createEmptySelectionState = (): NetworkIntegrityProviderSelectionState => ({
  providerAndProviderSetVersionIds: new Set(),
  selectionMode: NetworkIntegrityProviderSelectionMode.Include
});

const toSelectionDto = (state: NetworkIntegrityProviderSelectionState, searchTerm?: string, regionSetIds?: number[], specialtyCodes?: string[], actionStatus?: NetworkIntegrityActionStatus, npiEntityType?: EntityTypeEnum | null): NetworkIntegrityProviderSelectionStateDto => ({
  actionStatus,
  npiEntityType: npiEntityType ?? null,
  providerAndProviderSetVersionIds: Array.from(state.providerAndProviderSetVersionIds) || [],
  regionSetIds: regionSetIds ?? [],
  search: searchTerm || "",
  selectionCount: state?.providerAndProviderSetVersionIds?.size || 0,
  selectionMode: state?.selectionMode || NetworkIntegrityProviderSelectionMode.Unknown,
  specialtyCodes: specialtyCodes ?? []
});

export {
  createEmptySelectionState,
  toSelectionDto
}